export const UPDATE_TOKEN_A = "UPDATE_TOKEN_A"
export const UPDATE_TOKEN_B = "UPDATE_TOKEN_B"
export const UPDATE_LP = "UPDATE_LP"
export const UPDATE_SWAP_INPUT = "UPDATE_SWAP_INPUT"
export const UPDATE_SWAP_OUTPUT = "UPDATE_SWAP_OUTPUT"
export const UPDATE_SWAP_EXPECT = "UPDATE_SWAP_EXPECT"
export const UPDATE_ADD_INPUT = 'UPDATE_ADD_INPUT'
export const UPDATE_ADD_INPUT_2 = 'UPDATE_ADD_INPUT_2'
export const UPDATE_TOKEN_A_ADDRESS = "UPDATE_TOKEN_A_ADDRESS"
export const UPDATE_TOKEN_B_ADDRESS = "UPDATE_TOKEN_B_ADDRESS"